import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LoadingMode } from '../Components/LoadingMode';
import { getToken } from '../utils';

export const Otppage = () => {
  const otp = useLocation();

  const otpId = otp.state.otpType;

  const [isSubmiting, setisSubmiting] = useState(false);
  const [otpType, setOtpType] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { token: userToken, user: { email: userEmail } = {} } = getToken();

  const [inputs, setInputs] = useState({ otp: '' });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const target = e.target;
    const value = target.value.slice(0, 6);
    const name = target.name;
    setInputs((input) => ({
      ...input,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchOtpType = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/dashboard/all-settings`
        );
        setOtpType(response.data.otp_types);
      } catch (error) {
        console.log(error);
      }
    };
    fetchOtpType();
  }, []);

  function getOtpId(otpName) {
    const otpId = otpType.filter((otp) => otp.name === otpName)[0]?.id;
    return otpId;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      otp: inputs.otp,
      otp_type_id: getOtpId(otpId),
    };
    try {
      setIsLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/otps/verify`,
        data,
        {
          headers: { Authorization: `Bearer ${userToken}` },
        }
      );

      toast.success('Login successful');
      sessionStorage.setItem('isAuthenticated', JSON.stringify(response.data));
      setIsLoading(false);
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  const handleSubmitOtp = async () => {
    try {
      setisSubmiting(true);
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/otps/send`,
        {
          otp_type_id: getOtpId(otpId),
        },
        {
          headers: { Authorization: `Bearer ${userToken}` },
        }
      );
      toast.success('Otp code sent successfully !', {
        position: toast.POSITION.TOP_RIGHT,
      });
    } catch (err) {
      console.log(err);
    } finally {
      setisSubmiting(false);
    }
  };

  const inputReference = useRef(null);
  useEffect(() => {
    if (inputReference.current !== null) {
      inputReference.current.focus();
    }
  }, []);

  return (
    <div className='pt-28 bg-p-wh flex items-center flex-col mx-auto gap-16 rounded-lg px-6 max-w-lg font-pin'>
      <div className='text-center cursor-pointer'>
        <h1 className='text-xl  font-semibold text-p-pin pb-2'>
          Security Verification
        </h1>
        <p>
          Enter the 6 digit OTP code sent to {userEmail}. OTP is Valid for
          15mins
        </p>
      </div>
      <form
        className='flex items-center justify-center flex-col gap-8 w-full box-border'
        onSubmit={handleSubmit}
      >
        <div className='flex flex-col gap-2 w-full'>
          <input
            type='number'
            className='text-center [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none focus:outline-none focus:ring focus:b-mc border-2 w-full h-14 rounded-lg border-t-bk px-4'
            name='otp'
            value={inputs.otp}
            onChange={handleChange}
            required
            ref={inputs.otp ? null : inputReference}
          />
        </div>
        <div className='w-full text-center'>
          <button
            type='submit'
            className='text-p-wh justify-center  hover:bg-b-mc/75 focus:bg-b-mc/80 px-4 py-3 w-full my-4 font-semibold disabled:bg-b-mct bg-b-mc rounded-lg relative'
            disabled={isLoading}
          >
            Login
            {isLoading && <LoadingMode />}
          </button>
          <p>
            Did't receive code{' '}
            <button
              type='button'
              className='text-b-mc cursor-pointer font-semibold hover:text-b-mc/75'
              onClick={handleSubmitOtp}
            >
              {isSubmiting ? 'Processing...' : 'Resend'}
            </button>
          </p>
        </div>
      </form>
    </div>
  );
};
